import { Reducer } from "redux";
import { ApplicationStore } from "./interfaces/store";
import {
  UpdateStatus,
  SetPreviewFlag,
  SetRoutes,
  SetActiveRoute,
  MapRoutes
} from "./interfaces/actions";
import { DEFAULT_ROUTES } from "Config/routes";

/**
 * The Application reducer for the Application store.  Contains information
 * related to the overall application, e.g. initialization status and flash
 * messages.
 * @param state An object representing the current state of the Application
 * store.
 * @param action An action creator for updating the supplied state.
 */
export const APPLICATION_REDUCER: Reducer<
  ApplicationStore,
  UpdateStatus | SetPreviewFlag | SetRoutes | MapRoutes | SetActiveRoute
> = (
  state = {
    status: "initializing",
    preview_flag: false,
    routes: Object.entries(DEFAULT_ROUTES).map(([k, v]) => ({
      id: v.id,
      path: v.path
    })),
    route_page: [],
    active_route: {
      id: "",
      path: ""
    },
    navExpanded: true
  },
  action
) => {
  switch (action.type) {
    case "APPLICATION__UPDATE_STATUS":
      return {
        ...state,
        status: action.status
      };
    case "APPLICATION__SET_PREVIEW_FLAG":
      return {
        ...state,
        preview_flag: action.preview_flag
      };
    case "APPLICATION__SET_ROUTES":
      return {
        ...state,
        routes: action.routes
      };
    case "APPLICATION__SET_ACTIVE_ROUTE":
      return {
        ...state,
        active_route: action.route
      };
    case "APLLICATION__MAP_ROUTES":
      return {
        ...state,
        route_page: action.mappings
      };
    default:
      return state;
  }
};
